module.exports = __webpack_public_path__ + "media/images/commercial_offers/big_logo-607ce022c1ff970128f3b5e4054070f0.png";